module.exports = __webpack_public_path__ + "static/consultancy-7f867ff30f0a1a848917554b5e07a747.mp4";